// extracted by mini-css-extract-plugin
module.exports = {"root":"ListingChip_root__ZVcmf"};